/**
 * @fileoverview POST handler for the "/engagement/segments/:segment_id/migrate_filters" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsSegmentIdMigrateFiltersCacheKeys } from "./constants";
import type { PostEngagementSegmentsSegmentIdMigrateFiltersProps } from "./types";

export const engagementSegmentsMigrateFilters = reactQueryMutationAdapter(
  engagementSegmentsSegmentIdMigrateFiltersCacheKeys,
  ({ segmentId, ...props }: PostEngagementSegmentsSegmentIdMigrateFiltersProps): Promise<{}> => {
    return fetch(`/engagement/segments/${segmentId}/migrate_filters`, "POST", props);
  }
);
